import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centered-page-wrapper',
  templateUrl: './centered-page-wrapper.component.html',
  styleUrls: ['./centered-page-wrapper.component.scss']
})
export class CenteredPageWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
